import { render } from "./AffiliationErrorPage.vue?vue&type=template&id=973c315a&scoped=true"
import script from "./AffiliationErrorPage.vue?vue&type=script&lang=js"
export * from "./AffiliationErrorPage.vue?vue&type=script&lang=js"

import "./AffiliationErrorPage.vue?vue&type=style&index=0&id=973c315a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-973c315a"]])

export default __exports__